export const _USER_ACTIVE = 'user-active'
export const _TOKEN_KEY = 'user-alertme'
//le a mensagens (app 402):
export const URL_MESSAGE_CHANEL = process.env.VUE_APP_PREFIX_API+'402'
//Deletar mensagens (app 403):
export const URL_DEL_MSG = process.env.VUE_APP_PREFIX_API+'403'
//Deletar mensagens (app 404):
export const URL_INS_MSG = process.env.VUE_APP_PREFIX_API+'404'
//Recuperar dados da instância (app 405):
export const URL_INFO_HOST = process.env.VUE_APP_PREFIX_API+'405'
//Cadastrar usuário (app 406):
export const URL_CAD_USER = process.env.VUE_APP_PREFIX_API+'406'
//Recuperar hosts (app 407):
export const URL_LIST_HOST = process.env.VUE_APP_PREFIX_API+'407'
//Recuperar user ou autenticacao (app 408):
export const URL_AUTH = process.env.VUE_APP_PREFIX_API+'408'
//logoff
export const URL_LOGOUT = process.env.VUE_APP_PREFIX_API+'499'
//Verifcar session (app 498):
export const URL_CHECK_SESSION = process.env.VUE_APP_PREFIX_API+'498'
//Atualizar descrição da instância (app 409):
export const URL_UPD_HOST = process.env.VUE_APP_PREFIX_API+'409'
//Mensagens pendentes e respondidas (app 410):
export const URL_MSG = process.env.VUE_APP_PREFIX_API+'410'
//Salvar profile (app 411):
export const URL_SAVE_PROFILE = process.env.VUE_APP_PREFIX_API+'411'
//Recuperar profile (app 412):
export const URL_PROFILE = process.env.VUE_APP_PREFIX_API+'412'
//Atualizar end_date e cams (app 413)
export const URL_UPD_CAM = process.env.VUE_APP_PREFIX_API+'413'
//busca cep
export const URL_FIND_CEP = process.env.VUE_APP_PREFIX_API+'497'
//reseta a senha do usuario
export const URL_RESET_PWD = process.env.VUE_APP_PREFIX_API+'496'
//salvar senha
export const URL_SAVE_PWD = process.env.VUE_APP_PREFIX_API+'414'
// retorna os planos 
export const URL_PLANS = process.env.VUE_APP_PREFIX_API+'415'
// url de checkout
export const URL_CHECKOUT = process.env.VUE_APP_PREFIX_API+'416'
// url de cancelamento da assinatura
export const URL_CANCELAMENTO_PLANO = process.env.VUE_APP_PREFIX_API+'417'
// url para listagem dos usuarios
export const URL_USUARIOS = process.env.VUE_APP_PREFIX_API+'418'
// url para listagem dos usuarios
export const URL_USUARIOS_DEL = process.env.VUE_APP_PREFIX_API+'419'


